import React, { useState, useEffect, useCallback } from "react";
import { useDispatch } from "react-redux";
import { Close } from "@material-ui/icons";
import { makeStyles } from "@material-ui/core/styles";
import { Dialog, DialogContent } from "@material-ui/core";
import { first } from "lodash";
import CampaignPreviewForm from "./CampaignPreviewForm";
import { launchesActions } from "../../../../store/launches/launchesActions";

const useStyles = makeStyles(theme => ({
  featuredImageTabs: {
    backgroundColor: "#ffffff",
    zIndex: "5",
    boxShadow: "0px 0px 6px rgba(0, 0, 0, 0.25)",
    borderRadius: "6px",
    maxHeight: "632px",
    width:"550px",
    overflowY: "hidden",
    padding: 0,
  },
  featuredImageTabsHeading: {
    fontSize: "22px",
    color: "#fff",
    padding: "15px",
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
       backgroundColor: "#3699FF",
    marginTop: "0"
  },
  userNote: {
    fontSize: "14px",
    fontWeight: "500",
    color: "#eb5757",
    position: "absolute",
    bottom: "70px",
    zIndex: 999,
    left: "20px",
  },
  fieldsOption: {
    display: "flex",
    flexDirection: "column",
    justifyContent: "flex-start",
    marginTop: "4px",
  },
}));

export const CampaignsPreviewModal = ({
    open,
    setOpen,
}) => {
    const classes = useStyles();
    // const dispatch = useDispatch();
  //   const [campaignData , setCampaignsData] = useState([])

  // useEffect(() => {
  //   setLoading(true);
  //   dispatch(launchesActions.onGetCampaignById(open)).then((res) => {
  //     if (res?.success) {
  //       setCampaignsData(res?.data)
  //     }
  //     setLoading(false)
  //   })
  // }, [open])
  return (
    <Dialog open={open} onClose={setOpen} className="viewCampaignModal">
    <DialogContent className={classes.featuredImageTabs} style={{paddingTop: "0"}}>
      <h2 className={classes.featuredImageTabsHeading}>
        { open?.id ? open?.subject : "New Campaigns" }
        <Close
          style={{
            cursor: "pointer",
          }}
          className={classes.closeTabs}
          onClick={() => setOpen(null)}
        />
      </h2>
      <CampaignPreviewForm
        open={open}
      />
    </DialogContent>
  </Dialog>
  )
};